import { nodeCanParseSubContent, syntaxCanParseSubContent } from './symbols.js';

export interface KMarkdownSyntax {
  name: string;
  matcher: (
    text: string,
    option: FullOption,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    parentNode: KMarkdownNode<Record<string, any>>
  ) => KMarkdownSyntaxMatchResult[];
}
export type KMarkdownSyntaxMatchResult = {
  startIndex: number;
  length: number;
  node?: KMarkdownNodeCreateOptions;
};
export type KMarkdownSyntaxMatchResultContent = (string | KMarkdownNodeCreateOptions)[];
export interface KMarkdownNodeCreateOptions {
  content: KMarkdownSyntaxMatchResultContent;
  name: string;
  option?: Record<string, unknown>;
  canParseSubContent?: boolean;
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export class KMarkdownNode<T extends Record<string, any> = Record<string, any>> {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [key: symbol]: any;
  readonly [nodeCanParseSubContent]: boolean = true;
  readonly [syntaxCanParseSubContent]: undefined | boolean = void 0;
  readonly id: string = '_SOURCE_CLASS';
  constructor(
    public content: KMarkdownNodeContent,
    public args: T,
    public createBy: string | null,
    canParseSubContent: boolean | undefined = undefined
  ) {
    this[syntaxCanParseSubContent] = canParseSubContent;
  }
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type KMarkdownNodeContent = (string | KMarkdownNode<Record<string, any>>)[];

export type SyntaxesGroup = {
  name: string;
  syntaxes: KMarkdownSyntax[];
  next?: string | undefined | null | (string | null)[];
};

export type BuiltSyntaxesGroup = SyntaxesGroup & {
  nextGroups: BuiltSyntaxesGroup[];
};

export type Option = Readonly<{
  syntaxes?: Readonly<SyntaxesGroup[]>;
  replacerTagStart?: string;
  replacerTagMap?: Readonly<{
    [key: symbol]: string;
    '\\': string;
    [key: string]: string;
  }>;
  nodeMap?: Readonly<{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    [key: string]: typeof KMarkdownNode<Record<string, any>>;
  }>;
  autoParseLink?: boolean;
}>;
export type FullOption = Required<Option>;
